export const formatNumber = (value) => {
    return value !== null && value !== undefined ? new Intl.NumberFormat().format(value) : '-';
};
